import { render, staticRenderFns } from "./ScrollCenterDialog.vue?vue&type=template&id=53660ae6&scoped=true"
import script from "./ScrollCenterDialog.vue?vue&type=script&lang=js"
export * from "./ScrollCenterDialog.vue?vue&type=script&lang=js"
import style0 from "./ScrollCenterDialog.vue?vue&type=style&index=0&id=53660ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53660ae6",
  null
  
)

export default component.exports